import WarehouseExportTypeTableItem from 'components/TableItem/WarehouseExportTypeTableItem';
import React, { useEffect, useState } from 'react';
import MyPagination from '../../components/Common/MyPagination';
import * as warehouseExportTypeApi from '../../apis/warehouseExportTypeApi';


import {
    Table,
    Card,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button,
} from "reactstrap"

import { Link, useHistory, withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { useQuery } from 'Utils/UseQuery';
import SweetAlert from 'react-bootstrap-sweetalert';
import ConfirmDelete from 'components/Common/ConfirmDelete';
import { getMessage } from './../../Utils/ErrMessageUtils';
import MetaTags from 'react-meta-tags';


function ListWarehouseExportType(props) {
    const [data, setData] = useState([])
    const [additionalData, setAdditionalData] = useState({})
    const [deleteId, setDeleteId] = useState(null);
    let history = useHistory();

    useEffect(() => {
        let page = useQuery(props.location.search).get('page');
        fetchData(page);
    }, [props.location.search])
    const fetchData = page => {
        warehouseExportTypeApi.getList(page, fetchDataSuccess, fetchDataFail)
    }
    const fetchDataSuccess = res => {
        setAdditionalData(res.data.data)
        setData(res.data.data.data);
    }
    const fetchDataFail = res => {
        alert(getMessage(res.message))
    }
    const showWarehouseExportTypes = () => {
        if (data.length === 0) {
            return (<tr></tr>);
        }
        return data.map((v, i) => {
            return (<WarehouseExportTypeTableItem key={i} data={v} count={i + 1} deleteCallback={setDeleteId} />)
        })
    }
    const onDelete = (id) => {
        warehouseExportTypeApi.deleteWarehouseExportType(id, deleteSuccess, deleteFail)
    }
    const deleteSuccess = (res) => {
        alert("Xóa thành công")
        setDeleteId(null)
        let page = useQuery(props.location.search).get('page');
        fetchData(page);
    }
    const deleteFail = (res) => {
        alert(getMessage(res.message))
        setDeleteId(null)
    }
    const onChangePage = (page) => {
        let url = props.location.pathname + '?page=' + page;
        history.push(url);
    }
    return (
        <div className="page-content">
            <MetaTags>
                <title>Danh sách loại phiếu xuất</title>
            </MetaTags>
            {deleteId ? (
                <ConfirmDelete
                    confirmCallback={() => {
                        onDelete(deleteId)
                    }}
                    cancelCallback={() => {
                        setDeleteId(null)
                    }}
                />
            ) : ''}
            <Card>
                <CardBody>
                    <CardTitle className="h4">Danh mục loại phiếu xuất</CardTitle>
                    <Row className="justify-content-between">
                        <Col xs="auto" sm="auto">

                        </Col>
                        <Col xs="auto" sm="auto">
                            <Link to="/warehouse-export-types/create">
                                <Button color='primary' className='px-3 rounded-pill'>
                                    <i className="fas fa-plus mr-2"></i> Thêm mới
                                </Button>
                            </Link>
                        </Col>
                    </Row>
                    <div className="table-responsive">
                        <Table className="table mb-3">
                            <thead>
                                <tr>
                                    <th>Mã loại phiếu xuất</th>
                                    <th>Tên loại phiếu xuất</th>
                                    {/* <th>Ghi chú</th> */}
                                    <th>Hành Động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {showWarehouseExportTypes()}
                            </tbody>
                        </Table>
                    </div>
                    <MyPagination 
                        startPage={additionalData.current_page ? additionalData.current_page : 1} 
                        totalItemsCount={additionalData.total ? additionalData.total : 5} 
                        itemsCountPerPage={additionalData.per_page ? additionalData.per_page : 10}
                        callback={onChangePage} />

                </CardBody>
            </Card>
        </div>
    )
}

ListWarehouseExportType.propTypes = {
    location: PropTypes.object,
}

export default withRouter(ListWarehouseExportType);
